module.exports = "/images/spinner-solid.svg?c613206794b535f9023aff56379b612e";